import { useCallback, useContext } from "react"
import { NormalizerContext } from "../NormalizerContext"
import { last, groupBy, cloneDeep } from "lodash"
import { useQueryClient } from "@tanstack/react-query"
import qc from "keys/queryClient"
import { changeItem } from "utils/array"

const useViewUpdatedScoreRating = () => {
    const { setOpenBackDrop, assessmentFilters, checkType, scoreRatingSemesters, activeScoreItemStatus, setActiveScoreItemStatus, activeScoreRatingIndex, stats, setStats, scoreRatingOptions } = useContext(NormalizerContext)

    const queryClient = useQueryClient()

    const groupByRating = (statsToGroup) => {
        const nStats = groupBy(Object.entries(statsToGroup), ([key, value]) => value.rating_index);
        const groupStats = Object.entries(nStats).reduce((acc, [rating, items]) => {
            acc[parseInt(rating)] = items.map(([key, value]) => ({ key, ...value }));
            return acc;
        }, {});

        return groupStats
    }

    return useCallback(async () => {
        setOpenBackDrop(true)

        const updatedGraph = stats[activeScoreRatingIndex]

        setActiveScoreItemStatus("view")

        let nStats = [...stats]
        let prevIndex = activeScoreRatingIndex - 1
        let nextIndex = activeScoreRatingIndex + 1

        let nextData = updatedGraph
        while (prevIndex >= 0) {
            const scoreRating = scoreRatingSemesters.data[prevIndex]
            let currentData = cloneDeep(queryClient.getQueryData([checkType.queryKey, scoreRating.grade, scoreRating.semester, scoreRating.category, scoreRating.method])?.graph)
            // let currentData = { ...nStats[prevIndex] }
            if (!currentData) {
                await queryClient.fetchQuery({
                    queryKey: [checkType.queryKey, scoreRating.grade, scoreRating.semester, scoreRating.category, scoreRating.method],
                    queryFn: async () => {
                        let filters = {
                            ...assessmentFilters,
                            category: assessmentFilters.category || scoreRating.category,
                            grade_of_execution: scoreRating.grade,
                            semester: scoreRating.semester,
                        }
                        if (scoreRating.method_name != "Normal_distribution")
                            filters.method = scoreRating.method

                        let { data } = await checkType.queryFn?.({ assessmentFilters: filters })
                        currentData = { ...data?.graph }
                        return data
                    },
                })
            }
            if (currentData) {
                let gSourceGraph = groupByRating(currentData)

                for (let i = 5; i > 0; i--) {
                    const gPrev = groupByRating(currentData)
                    const gNext = groupByRating(nextData)

                    if (gPrev[i]) {
                        const graphKey = last(gPrev[i]).key
                        const nextGraphKey = last(gNext[i]).key

                        if (Number(nextGraphKey) < Number(graphKey) && i != 1) {
                            for (let j = nextGraphKey + 1; j <= graphKey; j++) {
                                currentData[j] = {
                                    key: j,
                                    count: 0, percent: 0,
                                    ...currentData[j],
                                    rating_id: currentData[graphKey].rating_id - 1,
                                    rating_index: currentData[graphKey].rating_index - 1
                                }
                            }
                        }
                    }
                    else {
                        let startKey = gNext[i][0].key
                        let endKey = last(gNext[i]).key
                        const rating_index = gNext[i][1].rating_index
                        const rating_id = gSourceGraph[rating_index][1].rating_id

                        for (let j = startKey; j <= endKey; j++)
                            currentData[i] = {
                                key: j,
                                count: 0,
                                percent: 0,
                                ...currentData[j],
                                rating_id: rating_id,
                                rating_index: rating_index
                            }
                    }
                }
            }
            nStats[prevIndex] = currentData
            prevIndex--
            nextData = currentData
        }

        let prevData = updatedGraph
        while (nextIndex <= stats.length - 1) {
            const scoreRating = scoreRatingSemesters.data[nextIndex]
            let currentData = cloneDeep(queryClient.getQueryData([checkType.queryKey, scoreRating.grade, scoreRating.semester, scoreRating.category, scoreRating.method])?.graph)
            if (!currentData) {
                await queryClient.fetchQuery({
                    queryKey: [checkType.queryKey, scoreRating.grade, scoreRating.semester, scoreRating.category, scoreRating.method],
                    queryFn: async () => {
                        let filters = {
                            ...assessmentFilters,
                            category: assessmentFilters.category || scoreRating.category,
                            grade_of_execution: scoreRating.grade,
                            semester: scoreRating.semester,
                        }
                        if (scoreRating.method_name != "Normal_distribution")
                            filters.method = scoreRating.method

                        let { data } = await checkType.queryFn?.({ assessmentFilters: filters })
                        currentData = { ...data?.graph }
                        return data
                    },
                })

            }
            // let currentData = { ...nStats[nextIndex] }
            if (currentData) {
                let gSourceGraph = groupByRating(currentData)

                for (let i = 5; i > 0; i--) {
                    const gNext = groupByRating(currentData)
                    const gPrev = groupByRating(prevData)

                    if (gNext[i]) {
                        const graphKey = last(gNext[i]).key
                        if (!gPrev[i])
                            debugger
                        const prevGraphKey = last(gPrev[i]).key

                        if (Number(prevGraphKey) > Number(graphKey) && i != 1) {
                            for (let j = graphKey; j < prevGraphKey + 1; j++)
                                currentData[j] = {
                                    key: j,
                                    count: 0,
                                    percent: 0,
                                    ...nextData[j],
                                    rating_id: currentData[graphKey].rating_id,
                                    rating_index: currentData[graphKey].rating_index
                                }
                        }
                    }
                    else {
                        let startKey = gPrev[i][0].key
                        let endKey = last(gPrev[i]).key
                        let rating_index = gPrev[i]?.[1]?.rating_index
                        let rating_id = gSourceGraph[rating_index]?.[1]?.rating_id
                        if (!rating_index)
                            rating_index = gPrev[i]?.[0]?.rating_index
                        if (!rating_id)
                            rating_id = gSourceGraph[rating_index]?.[0]?.rating_id

                        for (let j = Number(startKey); j <= Number(endKey); j++)
                            currentData[j] = {
                                key: j,
                                count: 0,
                                percent: 0,
                                ...currentData[j],
                                rating_id: rating_id,
                                rating_index: rating_index
                            }
                    }
                }

            }
            nStats[nextIndex] = currentData
            nextIndex++
            prevData = currentData
        }

        setStats(nStats)
        setOpenBackDrop(false)
    }, [scoreRatingSemesters, checkType, scoreRatingOptions, stats])

}

export default useViewUpdatedScoreRating
